<template lang="pug">
.rooms-managerment
  h1 房间管理
  .rooms
    .room(v-for='room in rooms') {{room.no}}
</template>

<script>
export default {
  name: 'rooms-managerment',
  computed: {
    rooms() {
      return this.$store.state.summary.rooms
    },
  },
}
</script>



// WEBPACK FOOTER //
// RoomsManagement.vue?29e42116